import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../../config/firebase";
import { collection, getDocs, addDoc } from "firebase/firestore";

export const fetchBlackoutDates = createAsyncThunk(
  "blackoutDates/fetchBlackoutDates",
  async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "blackoutDates"));
      return querySnapshot.docs.map((doc) => doc.data()); // Simply return the date as it's already in string format
    } catch (error) {
      console.error("Error Fetching Blackout Dates:", error);
    }
  }
);

export const addBlackoutDate = createAsyncThunk(
  "blackoutDates/addBlackoutDate",
  async (date) => {
    try {
      console.log("Trying to add this date:", date);
      await addDoc(collection(db, "blackoutDates"), { date });
      return { date };
    } catch (error) {
      console.error("Error Adding Blackout Date:", error);
      throw error;
    }
  }
);

export const blackoutDatesSlice = createSlice({
  name: "blackoutDates",
  initialState: [],
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlackoutDates.fulfilled, (state, action) => {
        return action.payload;
      })
      .addCase(addBlackoutDate.pending, (state) => {
        // Maybe set a loading flag or log something
      })
      .addCase(addBlackoutDate.rejected, (state, action) => {
        // Handle or log the error. 'action.error' contains the error information
      })

      .addCase(addBlackoutDate.fulfilled, (state, action) => {
        state.push(action.payload.date);
      });
  },
});

export default blackoutDatesSlice.reducer;
